export default __webpack_public_path__ + "static/media/carousel-01-indumentaria-femenina-pt.d1e7b326.png";